<template>
  <div class="process-retest-form">
    <el-form 
      ref="retestForm" 
      :model="form" 
      :rules="rules" 
      label-width="120px"
      class="retest-form"
      v-loading="loading">
      
      <!-- 订单基本信息 -->
      <el-card class="form-card">
        <div slot="header">
          <span>订单基本信息</span>
        </div>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="项目名称" prop="projectName">
              <el-input v-model="form.projectName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="订单编号" prop="orderNo">
              <el-input v-model="form.orderNo" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="商家名称" prop="merchantName">
              <el-input v-model="form.merchantName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户名称" prop="customerName">
              <el-input v-model="form.customerName" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="仪器信息" prop="deviceInfo">
              <el-input v-model="form.deviceInfo" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="样品数量" prop="testCount">
              <el-input v-model="form.testCount" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>
      
      <!-- 测试要求信息 -->
      <el-card class="form-card">
        <div slot="header">
          <span>测试要求信息</span>
        </div>
        <!-- 测试要求附件 -->
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="测试要求附件">
              <div v-if="form.requirementFiles && form.requirementFiles.length > 0" class="file-list-container">
                <el-table
                  :data="form.requirementFiles"
                  style="width: 100%"
                  border>
                  <el-table-column
                    prop="name"
                    label="文件名"
                    min-width="300">
                  </el-table-column>
                  <el-table-column
                    prop="size"
                    label="大小"
                    width="150">
                    <template slot-scope="scope">
                      {{ formatFileSize(scope.row.size) }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    width="150"
                    align="center">
                    <template slot-scope="scope">
                      <el-button 
                        type="text" 
                        size="small" 
                        @click="handlePreview(scope.row)">预览</el-button>
                      <el-button 
                        type="text" 
                        size="small" 
                        @click="handleDownload(scope.row)" 
                        style="margin-left: 10px;">下载</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div v-else class="no-file">
                <el-empty description="暂无测试要求附件" :image-size="40"></el-empty>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="备注说明" prop="remarks">
              <el-input v-model="form.remarks" type="textarea" :rows="3" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>
        
      <!-- 测试结果信息 -->
      <el-card class="form-card">
        <div slot="header">
          <span>测试结果信息</span>
        </div>
        <!-- 测试结果附件 -->
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="测试结果附件">
              <div v-if="form.resultFiles && form.resultFiles.length > 0" class="file-list-container">
                <el-table
                  :data="form.resultFiles"
                  style="width: 100%"
                  border>
                  <el-table-column
                    prop="name"
                    label="文件名"
                    min-width="300">
                  </el-table-column>
                  <el-table-column
                    prop="size"
                    label="大小"
                    width="150">
                    <template slot-scope="scope">
                      {{ formatFileSize(scope.row.size) }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    width="150"
                    align="center">
                    <template slot-scope="scope">
                      <el-button 
                        type="text" 
                        size="small" 
                        @click="handlePreview(scope.row)">预览</el-button>
                      <el-button 
                        type="text" 
                        size="small" 
                        @click="handleDownload(scope.row)" 
                        style="margin-left: 10px;">下载</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div v-else class="no-file">
                <el-empty description="暂无测试结果附件" :image-size="40"></el-empty>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        
        <!-- 测试说明 -->
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="测试结果说明">
              <el-input v-model="form.testDescription" type="textarea" :rows="3" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>

      <!-- 申请复测信息 -->
      <el-card class="form-card">
        <div slot="header">
          <span>申请复测信息</span>
        </div>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="复测原因">
              <el-input 
                type="textarea" 
                v-model="form.retestReason"
                :rows="4"
                disabled>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 复测申请附件列表 -->
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="复测申请附件">
              <div v-if="form.retestFiles && form.retestFiles.length > 0" class="file-list-container">
                <el-table
                  :data="form.retestFiles"
                  style="width: 100%"
                  border>
                  <el-table-column
                    prop="name"
                    label="文件名"
                    min-width="300">
                  </el-table-column>
                  <el-table-column
                    prop="size"
                    label="大小"
                    width="150">
                    <template slot-scope="scope">
                      {{ formatFileSize(scope.row.size) }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    width="150"
                    align="center">
                    <template slot-scope="scope">
                      <el-button 
                        type="text" 
                        size="small" 
                        @click="handlePreview(scope.row)">预览</el-button>
                      <el-button 
                        type="text" 
                        size="small" 
                        @click="handleDownload(scope.row)" 
                        style="margin-left: 10px;">下载</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div v-else class="no-file">
                <el-empty description="暂无复测申请附件" :image-size="40"></el-empty>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>

      <!-- 处理复测 -->
      <el-card class="form-card">
        <div slot="header">
          <span>处理复测</span>
        </div>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="处理结果" prop="processResult" required>
              <el-radio-group v-model="form.processResult" class="radio-group-left">
                <el-radio label="PASS">接受复测</el-radio>
                <el-radio label="REJECT">驳回复测</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20" v-if="form.processResult === 'REJECT'">
          <el-col :span="24">
            <el-form-item label="处理意见" prop="processComment" required>
              <el-input 
                type="textarea" 
                v-model="form.processComment"
                :rows="4"
                placeholder="请输入处理意见">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 处理附件上传 -->
        <el-row :gutter="20" v-if="form.processResult === 'REJECT'">
          <el-col :span="24">
            <el-form-item label="处理相关附件">
              <el-upload
                action=""
                :http-request="customUpload"
                multiple
                :file-list="form.fileList"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :before-upload="beforeUpload"
                :on-error="handleUploadError"
                class="upload-demo"
                drag>
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip">支持上传PDF、Word、Excel或图片格式文件，每个文件不超过20MB</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-form-item class="form-actions">
          <el-button type="primary" @click="submitForm('retestForm')" :loading="loading">提交处理</el-button>
          <el-button @click="returnToList">返回列表</el-button>
        </el-form-item>
      </el-card>
    </el-form>
  </div>
</template>

<script>
import adminApi from '@/api/adminApi'

export default {
  name: 'ProcessRetestForm',
  props: {
    orderId: {
      type: [String, Number],
      required: false
    }
  },
  data() {
    return {
      loading: false,
      uploadingFiles: 0,
      localOrderId: null, // 添加本地ID变量存储实际使用的订单ID
      form: {
        projectName: '',
        orderNo: '',
        merchantName: '',
        customerName: '',
        deviceInfo: '',
        testCount: '',
        remarks: '',
        testDescription: '',
        retestReason: '',
        processResult: 'PASS', // 默认选中接受复测
        processComment: '',
        requirementFiles: [],
        resultFiles: [],
        retestFiles: [],
        uploadFiles: [],
        fileList: []
      },
      uploadFileList: [],
      rules: {
        processResult: [
          { required: true, message: '请选择处理结果', trigger: 'change' }
        ],
        processComment: [
          { 
            required: true, 
            message: '请输入处理意见', 
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (this.form.processResult === 'REJECT' && (!value || value.trim() === '')) {
                callback(new Error('请输入处理意见'));
              } else {
                callback();
              }
            }
          },
          { 
            min: 5, 
            max: 500, 
            message: '处理意见长度在5到500个字符之间', 
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (this.form.processResult === 'REJECT' && value && (value.length < 5 || value.length > 500)) {
                callback(new Error('处理意见长度在5到500个字符之间'));
              } else {
                callback();
              }
            }
          }
        ]
      }
    }
  },
  created() {
    // 优先使用props传入的订单ID，如果没有则从路由参数获取
    this.localOrderId = this.orderId || this.$route.params.id;
    
    // 输出调试信息
    console.log('Props订单ID:', this.orderId);
    console.log('路由参数订单ID:', this.$route.params.id);
    console.log('实际使用的订单ID:', this.localOrderId);
    
    if (!this.localOrderId) {
      this.$message.error('缺少订单ID参数，无法加载数据');
      console.error('处理复测组件缺少必要的订单ID参数');
      // 可以选择跳转回列表页
      setTimeout(() => {
        this.$router.push('/admin/orders/dispute');
      }, 2000);
      return;
    }
    
    this.getOrderDetail();
  },
  methods: {
    async getOrderDetail() {
      this.loading = true
      try {
        const res = await adminApi.getOrderById(this.localOrderId)
        console.log('获取到的订单详情:', res)
        if (res) {
          const orderData = res
          
          // 处理测试要求附件
          const requirementFiles = Array.isArray(orderData.orderFile) 
            ? orderData.orderFile.map(file => ({
                name: file.fileName || '未命名文件',
                size: file.fileSize || 0,
                url: file.fileUrl || file.url || '',
                fileId: file.fileId || file.id
              })) 
            : [];
          
          // 处理测试结果附件
          const resultFiles = Array.isArray(orderData.orderResultFile) 
            ? orderData.orderResultFile.map(file => ({
                name: file.fileName || '未命名文件',
                size: file.fileSize || 0,
                url: file.fileUrl || file.url || '',
                fileId: file.fileId || file.id
              })) 
            : [];
          
          // 获取复测申请信息
          let retestReason = '';
          let retestFiles = [];
          
          // 尝试从不同的数据结构中获取复测信息
          if (Array.isArray(orderData.orderRetestList) && orderData.orderRetestList.length > 0) {
            // 获取最新的复测记录
            const latestRetest = orderData.orderRetestList[0];
            
            // 尝试获取复测原因（可能在不同字段中）
            retestReason = latestRetest.disputeRemark || latestRetest.retestRemark || '';
            
            // 处理复测附件（可能在不同字段中）
            const disputeFiles = Array.isArray(latestRetest.orderDisputeFile) ? latestRetest.orderDisputeFile : [];
            const retestFileList = Array.isArray(latestRetest.orderRetestFile) ? latestRetest.orderRetestFile : [];
            
            // 合并可能的附件来源
            const allFiles = [...disputeFiles, ...retestFileList];
            
            if (allFiles.length > 0) {
              retestFiles = allFiles.map(file => ({
                name: file.fileName || '未命名文件',
                size: file.fileSize || 0,
                url: file.fileUrl || file.url || '',
                fileId: file.fileId || file.id
              }));
            }
          } else if (orderData.disputeRemark) {
            // 备选：直接从订单对象获取
            retestReason = orderData.disputeRemark || '';
            
            // 尝试从订单对象获取复测附件
            if (Array.isArray(orderData.orderDisputeFile)) {
              retestFiles = orderData.orderDisputeFile.map(file => ({
                name: file.fileName || '未命名文件',
                size: file.fileSize || 0,
                url: file.fileUrl || file.url || '',
                fileId: file.fileId || file.id
              }));
            }
          }
          
          this.form = {
            ...this.form,
            projectName: orderData.projectName || '',
            orderNo: orderData.orderSn || '',
            merchantName: orderData.merchantName || '',
            customerName: orderData.customerName || '',
            deviceInfo: orderData.deviceName || '',
            testCount: orderData.testCount || '0',
            remarks: orderData.remarks || '',
            testDescription: orderData.testResultRemark || '',
            retestReason: retestReason,
            retestFiles: retestFiles,
            requirementFiles: requirementFiles,
            resultFiles: resultFiles,
            fileList: []
          }
          
          console.log('复测原因:', retestReason)
          console.log('复测附件:', retestFiles)
        } else {
          this.$message.error('获取订单详情失败')
        }
      } catch (error) {
        console.error('获取订单详情失败:', error)
        this.$message.error('获取订单详情失败: ' + (error.message || '未知错误'))
      } finally {
        this.loading = false
      }
    },
    formatFileSize(size) {
      if (!size) return '0 B'
      const units = ['B', 'KB', 'MB', 'GB']
      let index = 0
      let formattedSize = size
      
      while (formattedSize >= 1024 && index < units.length - 1) {
        formattedSize /= 1024
        index++
      }
      
      return `${formattedSize.toFixed(2)} ${units[index]}`
    },
    handlePreview(file) {
      // 调用统一的预览方法
      adminApi.previewFile(file, this.$message)
        .catch(error => {
          console.error('文件预览失败:', error);
        });
    },
    handleDownload(file) {
      // 调用统一的下载方法
      adminApi.downloadFileUnified(file, this.$message)
        .catch(error => {
          console.error('文件下载失败:', error);
        });
    },
    beforeUpload(file) {
      // 检查文件大小
      const isLt20M = file.size / 1024 / 1024 < 20
      if (!isLt20M) {
        this.$message.error('文件大小不能超过20MB!')
        return false
      }
      
      // 检查文件类型
      const allowedTypes = [
        'application/pdf', 
        'application/msword', 
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'image/jpeg',
        'image/png',
        'image/gif'
      ]
      
      const isAllowedType = allowedTypes.includes(file.type)
      if (!isAllowedType) {
        this.$message.warning('请上传PDF、Word、Excel或图片格式的文件')
        return false
      }
      
      return true
    },
    customUpload({ file, onSuccess, onError }) {
      this.uploadingFiles++
      
      adminApi.uploadFile(file, this.localOrderId)
        .then(response => {
          if (response && response.data && response.data.code === 200) {
            const fileData = response.data.data
            
            // 创建文件记录
            const uploadedFile = {
              name: file.name,
              size: file.size,
              url: fileData.fileUrl,
              fileId: fileData.fileId
            }
            
            // 添加到上传文件列表
            this.form.fileList.push(uploadedFile)
            
            // 添加到uploadFiles用于提交
            this.form.uploadFiles.push({
              fileId: fileData.fileId,
              fileName: file.name,
              fileUrl: fileData.fileUrl,
              fileSize: file.size
            })
            
            onSuccess(uploadedFile)
            this.$message.success(`文件 ${file.name} 上传成功`)
          } else {
            onError(new Error(response?.data?.msg || '上传失败'))
            this.$message.error(`文件 ${file.name} 上传失败`)
          }
        })
        .catch(error => {
          onError(error)
          this.$message.error(`文件 ${file.name} 上传失败，请重试`)
        })
        .finally(() => {
          this.uploadingFiles--
        })
    },
    handleRemove(file) {
      // 从上传文件列表中移除
      const index = this.form.fileList.findIndex(item => item.name === file.name)
      if (index !== -1) {
        this.form.fileList.splice(index, 1)
      }
      
      // 从uploadFiles中移除
      const fileIndex = this.form.uploadFiles.findIndex(item => 
        item.fileName === file.name || item.fileId === file.fileId)
      if (fileIndex !== -1) {
        this.form.uploadFiles.splice(fileIndex, 1)
      }
    },
    handleUploadError(err) {
      console.error('上传错误:', err)
      this.$message.error('文件上传失败，请重试')
      this.uploadingFiles--
    },
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          if (this.form.processResult === 'REJECT' && this.uploadingFiles > 0) {
            this.$message.warning(`还有 ${this.uploadingFiles} 个文件正在上传，请等待上传完成后再提交`)
            return
          }
          
          try {
            this.loading = true
            
            // 构建提交数据，参考ResolveDisputeForm.vue的实现方式
            const submitData = {
              id: this.localOrderId,
              orderSn: this.form.orderNo,
              orderStatus: 'RETEST',
              disputeResult: this.form.processResult,
              testResultRemark: this.form.processResult === 'REJECT' ? this.form.processComment : ''
            }
            
            // 拒绝复测时添加附件
            if (this.form.processResult === 'REJECT') {
              submitData.orderRetestFile = this.form.uploadFiles.map(file => ({
                fileId: file.fileId,
                fileName: file.name,
                fileUrl: file.url,
                fileSize: file.size,
                filePath: file.path
              }))
            }
            
            // 调用API处理复测
            const response = await adminApi.editOrder(submitData)
            console.log('提交结果:', response)
            if (response) {
              this.$message.success('复测处理提交成功')
              setTimeout(() => {
                this.returnToList()
              }, 1500)
            } else {
              this.$message.error(response?.data?.msg || '提交失败')
            }
          } catch (error) {
            console.error('提交处理复测失败:', error)
            this.$message.error('提交失败，请重试')
          } finally {
            this.loading = false
          }
        } else {
          this.$message.error('请完善表单信息')
          return false
        }
      })
    },
    returnToList() {
      // 根据用户角色决定返回的路径
      const userRole = localStorage.getItem('userRole');
      if (userRole === 'merchant') {
        // 商家端用户返回到商家端的争议/复测订单列表
        this.$router.push('/merchant/orders/dispute');
      } else {
        // 管理端用户返回到管理端的争议/复测订单列表
        this.$router.push('/admin/orders/dispute');
      }
    }
  }
}
</script>

<style scoped>
.process-retest-form {
  width: 100%;
}

.retest-form {
  width: 100%;
}

.form-card {
  width: 100%;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}

.form-card .el-card__header {
  padding: 15px 20px;
  border-bottom: 1px solid #ebeef5;
  font-weight: bold;
}

.el-form-item {
  margin-bottom: 22px;
  width: 100%;
}

.el-input,
.el-select,
.el-date-picker,
.el-radio-group,
.el-upload,
.el-textarea {
  width: 100%;
}

/* 表单操作按钮 */
.form-actions {
  margin-top: 30px;
  text-align: center;
}

.form-actions .el-button {
  min-width: 120px;
  margin: 0 10px;
}

/* 上传区域样式 */
.upload-demo {
  width: 100%;
}

.el-upload__tip {
  margin-top: 10px;
  color: #909399;
}

/* 文件列表标题 */
.file-list-title {
  margin-top: 20px;
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: bold;
}

.uploaded-files {
  margin-top: 20px;
}

.no-file {
  padding: 10px;
  background-color: #f9f9f9;
  border-radius: 4px;
}

.no-file .el-empty {
  padding: 10px;
}

.no-file .el-empty__image {
  width: 40px;
  height: 40px;
}

.no-file .el-empty__description {
  margin-top: 5px;
  font-size: 12px;
}

/* 预览容器 */
.preview-container {
  width: 100%;
  height: 500px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f5f7fa;
}

/* 删除之前的radio样式 */
.custom-radio-container {
  display: flex;
  flex-wrap: wrap;
}

.custom-radio {
  margin-right: 30px;
  display: inline-flex;
  align-items: center;
  margin-bottom: 10px;
}

::v-deep .el-radio {
  margin-right: 0;
  display: flex;
  align-items: center;
  height: auto;
}

::v-deep .el-radio__input {
  line-height: 1;
}

::v-deep .el-radio__label {
  padding-left: 5px;
  font-size: 14px;
  line-height: 1;
}

/* 确保表单项文字与值对齐 */
.el-form-item__label,
.el-form-item__content {
  display: flex;
  align-items: center;
}

/* 参考UploadTestResult.vue添加新样式 */
/* 单选框组靠左对齐 */
.radio-group-left {
  text-align: left;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 32px;
  line-height: 32px;
}

/* 修复单选框与标签文字对齐问题 */
.el-radio {
  margin-right: 30px;
  display: flex;
  align-items: center;
  height: 32px;
  line-height: 32px;
}

.el-radio__input {
  vertical-align: middle;
  display: inline-flex;
  align-items: center;
  height: 14px;
  line-height: 14px;
}

.el-radio__label {
  vertical-align: middle;
  font-size: 14px;
  padding-left: 6px;
}

/* 修复处理结果标签与单选框组的对齐问题 */
.el-form-item.is-required .el-form-item__label:before {
  vertical-align: middle;
}

.el-form-item__label {
  line-height: 32px !important;
  display: flex;
  align-items: center;
  height: 32px;
}

.el-form-item__content {
  line-height: 32px !important;
  display: flex;
  align-items: center;
  min-height: 32px;
}

::v-deep .el-radio__inner {
  vertical-align: middle;
}

/* 调整Radio组件样式 */
.process-retest-form .el-radio {
  margin-right: 30px;
  line-height: 32px;
  height: 32px;
}

.process-retest-form .el-radio__input {
  vertical-align: middle;
}

.process-retest-form .el-radio__inner {
  vertical-align: middle;
}

.process-retest-form .el-radio__label {
  vertical-align: middle;
  padding-left: 6px;
}

/* 修复无障碍访问问题 */
.process-retest-form .el-radio__original {
  opacity: 0;
  outline: none;
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0;
}

/* 添加辅助屏幕阅读器类 */
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* 修复Element UI无障碍问题 */
.el-radio input[type="radio"] {
  position: absolute !important;
  cursor: pointer !important;
  opacity: 0 !important;
  height: 14px !important;
  width: 14px !important;
  margin: 0 !important;
  z-index: 9 !important;
  top: 0 !important;
  left: 0 !important;
}

/* 原生radio元素样式 */
.original-radio {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
  margin: 0;
}
</style>

<!-- 添加全局样式 -->
<style>
.process-retest-form .el-textarea__inner {
  font-family: inherit !important;
  font-size: 14px !important;
  line-height: 1.5 !important;
  color: #606266 !important;
}

.process-retest-form .el-form-item__label,
.process-retest-form .el-form-item__content {
  line-height: 32px !important;
}

/* 调整Radio组件样式 */
.process-retest-form .el-radio {
  margin-right: 30px;
  line-height: 32px;
  height: 32px;
}

.process-retest-form .el-radio__input {
  vertical-align: middle;
}

.process-retest-form .el-radio__inner {
  vertical-align: middle;
}

.process-retest-form .el-radio__label {
  vertical-align: middle;
  padding-left: 6px;
}
</style> 